export class TransporterEnum {
  static readonly GOEVIA = new TransporterEnum('goevia');
  static readonly DEMO = new TransporterEnum('demo');
  static readonly DGS_ONECLICK = new TransporterEnum('dgs-oneclick');
  static readonly LHERITIER = new TransporterEnum('lheritier');
  static readonly TAROT = new TransporterEnum('tarot');
  static readonly BECKER = new TransporterEnum('becker');
  static readonly EVOLUTRANS = new TransporterEnum('evolutrans');
  static readonly BERGES = new TransporterEnum('berges');
  static readonly SOTRIME = new TransporterEnum('sotrime');
  static readonly PROVENCE_DISTRIBUTION = new TransporterEnum('provence-distribution');
  static readonly MDL = new TransporterEnum('mdl');
  static readonly SETAK = new TransporterEnum('setak');
  static readonly LOCTRANS = new TransporterEnum('loctrans');
  static readonly GIRARD = new TransporterEnum('girard');
  static readonly DUMARTIN = new TransporterEnum('dumartin');
  static readonly SOGRANLOTRANS = new TransporterEnum('sogranlotrans');
  static readonly LGT = new TransporterEnum('lgt');
  static readonly ABO = new TransporterEnum('abo');
  static readonly MORIN = new TransporterEnum('morin');
  static readonly AUNIS = new TransporterEnum('aunis');
  static readonly DEPAEUW = new TransporterEnum('depaeuw');
  static readonly VINGEANNE = new TransporterEnum('vingeanne');
  static readonly ROUSSEAU = new TransporterEnum('rousseau');
  static readonly LDPI = new TransporterEnum('ldpi');
  static readonly CLOT = new TransporterEnum('clot');
  static readonly TPC = new TransporterEnum('tpc');
  static readonly TDF = new TransporterEnum('tdf');
  static readonly CHAVIGNY = new TransporterEnum('chavigny');
  static readonly AGENEAU = new TransporterEnum('ageneau');

  public readonly technicalName: string;
  private constructor(technicalName: string) {
    this.technicalName = technicalName;
  }

  public is(technicalName?: string | null): boolean {
    return this.technicalName === technicalName;
  }
}
